import React from 'react';
import PageLayout from '../../componentsV2/PageLayout/PageLayout';

const EmailVerificationCancelledPage = () => {
  return (
    <PageLayout
      pageTitle="Email Change Cancelled"
      shouldShowPageHeader
      shouldShowBreadcrumbs={false}
    >
      <div className="my-4 pl-2">
        <p className="text-lg text-vamos-dark mb-4">
          The email change request has been successfully cancelled.
        </p>

        <p className="mb-6 text-vamos-dark">
          Your email address remains unchanged.
        </p>

        <div className="mb-6">
          <p className="font-semibold text-vamos-dark">
            <strong>Security tip:</strong> If you believe your account may be
            compromised, please change your password and contact our support team at
            <a
              href="mailto:vamos@codethedream.org"
              className="text-vamos-blue underline ml-2 hover:text-vamos-blue-dark"
            >
              vamos@codethedream.org
            </a>
          </p>
        </div>

        <p className="text-sm text-vamos-gray">
          You can now close this window.
        </p>
      </div>
    </PageLayout>
  );
};

export default EmailVerificationCancelledPage;
